"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _constants = require("../../Icon/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellWithMessageDate(_ref) {
  var date = _ref.date,
      isReplied = _ref.isReplied;
  var className = (0, _utils.getClassNames)('table-cell_with_message_date', {
    'table-cell_with_message_date-replied': isReplied
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, isReplied ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: _constants.ICON_TYPE_BELL
  }) : /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, date));
}

CellWithMessageDate.propTypes = {
  isReplied: _propTypes.default.bool,
  date: _propTypes.default.string
};
CellWithMessageDate.defaultProps = {
  isReplied: true,
  date: null
};
var _default = CellWithMessageDate;
exports.default = _default;